import React from 'react';
import { NavLink } from 'react-router-dom';
import './FooterComponent.scss';
import MailingListSignupComponent from '../MailingListSignupComponent';
import experiences from '../../data/experiences.json';
import budapestPrivateTours from '../../data/experiences/budapest-private-tours.json';
import danubeCruises from '../../data/experiences/danube-cruises.json';
import countrysideTours from '../../data/experiences/countryside-tours.json';
import flyOverBudapest from '../../data/experiences/fly-over-budapest.json';
import croatiaTransfers from '../../data/experiences/croatia-transfers.json';
import austriaTransfers from '../../data/experiences/austria-transfers.json';
import HelpSectionComponent from '../HelpSectionComponent';
import PartnersStatsComponent from '../PartnersStatsComponent';

const FooterComponent = () => {
  const experiencesSubLinks = {
    'croatia-transfers': croatiaTransfers,
    'austria-transfers': austriaTransfers,
    'budapest-private-tours': budapestPrivateTours,
    'danube-cruises': danubeCruises,
    'countryside-tours': countrysideTours,
    'fly-over-budapest': flyOverBudapest
  };

  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <PartnersStatsComponent />
      <MailingListSignupComponent />
      <HelpSectionComponent />

      <div className="footer-main">
        <div className="container">
          <div className="row">
            <div className="col-lg-3 col-md-6 mb-4 mb-md-0">
              <h5>Destinations</h5>
              <ul className="no-style">
                <li>
                  <NavLink to="/destinations/budapest-to-vienna-private-transfer">Budapest to Vienna Transfer</NavLink>
                </li>
                <li>
                  <NavLink to="/destinations/vienna-to-budapest-private-transfer">Vienna to Budapest Transfer</NavLink>
                </li>
                <li>
                  <NavLink to="/destinations/budapest-to-debrecen-private-transfer">Budapest to Debrecen Transfer</NavLink>
                </li>
                <li>
                  <NavLink to="/destinations/budapest-to-bratislava-private-transfer">Budapest to Bratislava Transfer</NavLink>
                </li>
                <li>
                  <NavLink to="/destinations/budapest-to-heviz-private-transfer">Budapest to Hévíz Transfer</NavLink>
                </li>
                <li>
                  <NavLink to="/destinations/budapest-to-balatonfured-private-transfer">Budapest to Balatonfüred, Lake Balaton Transfer</NavLink>
                </li>
                <li>
                  <NavLink to="/destinations/budapest-to-prague-private-transfer">Budapest to Prague Transfer</NavLink>
                </li>
                <li>
                  <NavLink to="/destinations/budapest-to-zagreb-private-transfer">Budapest to Zagreb Transfer</NavLink>
                </li>
                <li>
                  <NavLink to="/destinations/budapest-to-split-private-transfer">Budapest to Split Transfer</NavLink>
                </li>
                <li>
                  <NavLink to="/destinations/budapest-to-dubrovnik-private-transfer">Budapest to Dubrovnik Transfer</NavLink>
                </li>
                <li>
                  <NavLink to="/destinations/budapest-to-zadar-private-transfer">Budapest to Zadar Transfer</NavLink>
                </li>
                <li>
                  <NavLink to="/destinations/budapest-to-salzburg-private-transfer">Budapest to Salzburg Transfer</NavLink>
                </li>
                <li>
                  <NavLink to="/destinations/budapest-to-graz-private-transfer">Budapest to Graz Transfer</NavLink>
                </li>
                <li>
                  <NavLink to="/destinations/budapest-to-szantod-private-transfer">Budapest to Szántód Transfer</NavLink>
                </li>
              </ul>

              <h5>Country Destinations</h5>
              <ul className="no-style">
                <li>
                  <NavLink to="/destinations/budapest-to-croatia-private-transfer">Budapest to Croatia Transfers</NavLink>
                </li>
                <li>
                  <NavLink to="/destinations/budapest-to-austria-private-transfer">Budapest to Austria Transfers</NavLink>
                </li>
              </ul>

              <h5>Services</h5>
              <ul className="no-style">
                <li>
                  <NavLink to="/budapest-airport-transfer">Budapest Airport Transfer</NavLink>
                </li>
                <li>
                  <NavLink to="/booking#city-to-city-transfer">City to City Transfer</NavLink>
                </li>
                <li>
                  <NavLink to="/bus-rental-budapest">Bus Rental Budapest</NavLink>
                </li>
                <li>
                  <NavLink to="/private-budapest-chauffeur-service">Private Budapest Chauffeur Service</NavLink>
                </li>
              </ul>
            </div>

            <div className="col-lg-3 col-md-6 mb-4 mb-md-0">
              <h5>Sitemap</h5>
              <ul className="no-style">
                <li>
                  <NavLink to="/about">About Us</NavLink>
                </li>
                <li>
                  <NavLink to="/destinations">Destinations</NavLink>
                </li>
                <li>
                  <NavLink to="/help-center">Contact</NavLink>
                </li>
                <li>
                  <NavLink to="/booking">Booking</NavLink>
                </li>
                <li>
                  <NavLink to="/help-center">Frequently Asked Questions</NavLink>
                </li>
                <li>
                  <NavLink to="/privacy-policy">Privacy Policy</NavLink>
                </li>
                <li>
                  <NavLink to="/terms-and-conditions">Terms and Conditions</NavLink>
                </li>
              </ul>
            </div>

            <div className="col-lg-3 col-md-6 mb-4 mb-md-0">
              <h5>Experiences</h5>
              <ul className="no-style">
                {experiences.map((experience) => (
                  <li key={experience.id} className="mb-3">
                    <b><NavLink to={experience.link}>{experience.title}</NavLink></b>
                    {experiencesSubLinks[experience.id] && (
                      <ul className="no-style mt-2">
                        {experiencesSubLinks[experience.id].map((subExperience) => (
                          <li key={subExperience.id}>
                            <a href={subExperience.link}>{subExperience.title}</a>
                          </li>
                        ))}
                      </ul>
                    )}
                  </li>
                ))}
              </ul>
            </div>

            <div className="col-lg-3 col-md-6">
              <h5>Contact Us</h5>
              <ul className="contact-info no-style">
                <li>
                  <i className="fa-brands fa-whatsapp"></i>
                  <span>Whatsapp only: <a href="https://wa.me/36707177656" target="_blank" rel="noreferrer">+36 70 717 7656</a></span>
                </li>
                <li>
                  <i className="fa-sharp fa-regular fa-at"></i>
                  <a href="mailto:info@pickuphungary.com">info@pickuphungary.com</a>
                </li>
                <li>
                  <i className="fa-sharp fa-regular fa-map-marker"></i>
                  <span>1124 Budapest, Kiss János altábornagy utca 55-59.</span>
                </li>
              </ul>

              <div className="social-media">
                <a target="_blank" rel="noopener noreferrer" href="https://www.facebook.com/Pickup-Hungary-101550984884677" title="Pickup Hungary on Facebook">
                  <i className="fa-brands fa-facebook"></i> Find us on Facebook
                </a>
              </div>

              <div className="company-info mt-4">
                <h5>Company Information</h5>
                <ul className="no-style">
                  <li>Spa Thermal Travel Kft.</li>
                  <li>Mailing Address: 1124 Budapest, Kiss János altábornagy utca 55-59., Hungary</li>
                  <li>Company Registration Number: 14 09 314248</li>
                  <li>VAT Number: HU24958952</li>
                  <li>License Number: U-001568</li>
                </ul>

                <a href="https://airporttransfer.com/" target="_blank" rel="noreferrer">
                  <img src="/images/at-partner-logo.png" alt="Airport Transfer partner logo" />
                </a>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-12">
              <div className="payment-methods">
                <img 
                  src="/images/Barion-card-payment-mark-2017-400px.webp" 
                  alt="Accepted payment methods: Visa, Mastercard, Maestro, Amex" 
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6">
              <i className="fa-regular fa-copyright me-2"></i> Copyright 2020 - {currentYear}, SPA Thermal Travel Hungary Kft.
            </div>
            <div className="col-md-6 text-md-end mt-3 mt-md-0">
              <a href="http://devology.io" target="_blank" rel="noopener noreferrer">
                DEV with <i className="fa-solid fa-heart heart-icon mx-1"></i> by DEVOLOGY.IO Limited (London, GB)
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default React.memo(FooterComponent);
